import React from 'react'
import AuthUI from './SignIn'
import { AuthType } from '../../types/enums'

// Candidate and employer registration share validation, recovery, and measurement.
export default function SignUp({ type }: { type: AuthType }) {
  return <AuthUI type={type} initialMode="signUp" />
}
